import {writable} from 'svelte/store';
import type {
  ValidationError,
  ValidationErrorBody,
} from 'Utility/validations/types';

const {subscribe, set, update} = writable<{
  [inputName: string]: ValidationError;
}>({});

const updateErrors = (field: string, validationError: ValidationErrorBody) => {
  update(prevObj => {
    prevObj[field] = Object.assign({...prevObj[field], ...validationError});
    return prevObj;
  });
};

const resetErrors = () => {
  set({});
};

const errors = {
  subscribe,
  set,
  updateErrors,
  resetErrors,
};

export default errors;
